import { BodyXs } from "@/domains/design/components/body-xs"
import { ScaleInnerCard300 } from "@/domains/design/components/scale-inner-card-300"
import { LiquidityClassicStableIcon } from "@/domains/icons/huge-icons/monotone/liquidity-classic-stable"
import { LiquidityClassicVolatileIcon } from "@/domains/icons/huge-icons/monotone/liquidity-classic-volatile"
import { showDisplayType } from "@/lib/show-display-type"

export type ILiquidityPoolTypeCard = {
  pairType: "stable" | "volatile"
  isStable: boolean
  displayType: string
}

export const LiquidityPoolTypeCard = ({ pool }: { pool: ILiquidityPoolTypeCard }) => {
  if (!pool) {
    return null
  }
  return (
    <ScaleInnerCard300 className="flex items-center gap-2 px-2 py-1 text-xs text-t100">
      {pool.isStable ? (
        <LiquidityClassicStableIcon size={16} strokeWidth={1.5} />
      ) : (
        <LiquidityClassicVolatileIcon size={16} strokeWidth={1.5} />
      )}
      <BodyXs>{showDisplayType(pool.displayType, true, true)}</BodyXs>
    </ScaleInnerCard300>
  )
}
